// extracted by mini-css-extract-plugin
module.exports = {"container":"benefits-module--container--NTuS5","cardList":"benefits-module--cardList--3a5BM"};